import React from "react";
import { hydrate, render } from "react-dom";
import "./stylesheets/main.scss";
import { Router } from "react-router-dom";
import "babel-polyfill";
import DefaultLayout from "components/Layout/DefaultLayout";
import history from "helpers/History";

const rootElement = document.getElementById("root");

if (rootElement.hasChildNodes()) {
  hydrate(
    <Router history={history}>
      <DefaultLayout />
    </Router>,
    rootElement
  );
} else {
  render(
    <Router history={history}>
      <DefaultLayout />
    </Router>,
    rootElement
  );
}

// Hot Module Replacement
if (module.hot) {
  module.hot.accept();
}



// WEBPACK FOOTER //
// ./src/index.jsx